<template>
    <div>
        <SignInPC v-if="isPC"/>
        <SignInH5 v-else/>
    </div>
</template>
<script>

    import SignInH5 from '../components/SignInH5';
    import SignInPC from '../components/SignInPC';
    import { enableAppShare } from '../../../common/js/APP/share';
    export default {
        name: 'Index',
        components: {
            SignInPC,
            SignInH5
        },
        mounted() {
            enableAppShare({
                title: '前端高薪 NEXT 计划 | 定制未来',
                desc:'请一位P7+技术专家，为你量身定制学习成长计划',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20211130/1638278460589.png',
                picUrl:'https://s21.lgstatic.com/growth/activity/20211130/1638278460589.png'
            });
        }
    };
</script>
